import React from "react";

function MenuGeneralContainer({nombre, ico, slug, icons, btnSelected, evento, activeBg, color, activeColor}) {
    //console.log(btnSelected);
    //console.log(slug);
  return (
    <>
    <button
      style={btnSelected === slug ? { background: activeBg, color: activeColor } : {color: color}}
      className="btn-sidebar"
      onClick={evento}
    >
      {btnSelected != slug ? <img src={icons[ico]} /> : <img src={icons[ico + '2']} /> }
      <span>{nombre}</span>
    </button>
    </>
  );
}

export default MenuGeneralContainer;
